import { useEffect, useState } from "react";
import {
  getStoredTrackingConsent,
  hasAnyTrackingProviderConfigured,
  initializeTracking,
  setTrackingConsent,
} from "../services/googleTag";

export default function ConsentBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    initializeTracking();
    const storedConsent = getStoredTrackingConsent();
    if (storedConsent) {
      setTrackingConsent(storedConsent);
      setIsVisible(false);
      return;
    }
    setIsVisible(hasAnyTrackingProviderConfigured());
  }, []);

  if (!isVisible) return null;

  return (
    <aside className="consent-banner" role="dialog" aria-live="polite" aria-label="Tracking consent">
      <div className="consent-banner-copy">
        We use analytics and ad attribution cookies to measure campaign performance and conversions.
      </div>
      <div className="consent-banner-actions">
        <button
          type="button"
          className="consent-btn consent-btn-secondary"
          onClick={() => {
            setTrackingConsent("denied");
            setIsVisible(false);
          }}
        >
          Decline
        </button>
        <button
          type="button"
          className="consent-btn"
          onClick={() => {
            setTrackingConsent("granted");
            setIsVisible(false);
          }}
        >
          Accept
        </button>
      </div>
    </aside>
  );
}
